module.exports = __webpack_public_path__ + "img/组合642.103e9774.png";